import { render } from "./PWAPrompt.vue?vue&type=template&id=ece4d752"
import script from "./PWAPrompt.vue?vue&type=script&lang=js"
export * from "./PWAPrompt.vue?vue&type=script&lang=js"

import "./PWAPrompt.vue?vue&type=style&index=0&id=ece4d752&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__